import { Zap, Tag, Smartphone } from 'lucide-react';

export const FeatureSection = () => {
  const features = [
    {
      icon: Zap,
      title: 'Reservas rápidas',
      description: 'Completa tu compra en menos de 2 minutos con nuestro sistema optimizado',
    },
    {
      icon: Tag,
      title: 'Ofertas',
      description: 'Accede a descuentos exclusivos y promociones especiales todo el año',
    },
    {
      icon: Smartphone,
      title: 'Multi-plataforma',
      description: 'Usa Mexmo desde cualquier dispositivo: web, iOS o Android',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Left: Bus Image */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-[16px] overflow-hidden shadow-md">
              <img
                src="https://images.unsplash.com/photo-1570125909232-eb263c188f7e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
                alt="Terminal de autobuses moderna"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right: Features */}
          <div className="order-1 lg:order-2">
            <h2 className="mb-5">Lo que hacemos</h2>
            <p className="text-[#6B7280] text-lg mb-10 leading-relaxed">
              Mexmo te ofrece la mejor experiencia para reservar tus viajes en autobús
            </p>

            <div className="space-y-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index}
                    className="bg-[#F7F8FA] rounded-[16px] p-6 border border-[#E5E7EB] hover:border-[#D1D5DB] transition-all"
                  >
                    <div className="flex gap-5">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 bg-white rounded-[14px] flex items-center justify-center border border-[#E5E7EB]">
                          <Icon className="w-6 h-6 text-[#FF6A2A]" />
                        </div>
                      </div>
                      <div>
                        <h4 className="mb-2">{feature.title}</h4>
                        <p className="text-[#6B7280] leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};